import { render, staticRenderFns } from "./ContactPersonCard.vue?vue&type=template&id=04328a39&scoped=true&"
import script from "./ContactPersonCard.vue?vue&type=script&scoped=true&lang=js&"
export * from "./ContactPersonCard.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./ContactPersonCard.vue?vue&type=style&index=0&id=04328a39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04328a39",
  null
  
)

export default component.exports